define('glu/flexDropdown/views/flexDropdownTooltipCollectionView',['require','../../collectionView','./flexDropdownTooltipItemView'],function(require) {
    'use strict';

    var CollectionView = require('../../collectionView'),
        FlexDropdownTooltipItemView = require('./flexDropdownTooltipItemView');

    return CollectionView.extend({
        itemView: FlexDropdownTooltipItemView
    });
});

